import { ListingCard } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';
import { ProductType } from 'marketplace-ui-common/types/products';
import { getHostAppName } from './getHostAppName';

/** Tracking properties that cannot be inferred from the `ListingCard`,
 * and thus must be provided separately. */
export interface TrackingProps {
  collectionId?: number;
  collectionSlug?: string;
  /** Override the host app name. Defaults to `getHostAppName()` (current window).
   * Pass `getHostAppName(window.parent)` when rendering inside an iframe where
   * the host app identity lives on the parent window (e.g. BA/CoPilot context). */
  hostApp?: string;
  pageNumber?: number;
  queryType?: string;
  resultIndex?: number;
  resultCount?: number;
  search?: string;
  section?: string;
  value?: string;
  [key: string]: string | number | undefined;
}

export function combineTrackingProps({
  componentType,
  listing,
  trackingProps,
}: {
  componentType: string;
  listing: ListingCard;
  trackingProps: TrackingProps | undefined;
}) {
  return {
    // inferred from `ListingCard`
    companyName: listing.companyName,
    installed: listing.products[0]?.installed,
    listingId: listing.listingId,
    portalInstallable: listing.products[0]?.portalInstallable,
    recommendationType: listing.recommendationSources?.map(
      (s) => `${s.sourceName}__${s.version}`
    ),
    slug: listing.slug,
    sourceId: listing.products.map(
      ({ sourceId, productType }) => `${String(productType)}__${sourceId}`
    ),
    type: listing.products[0]?.productType as ProductType,

    // provided by `TrackingProps`
    category: trackingProps?.collectionSlug,
    collectionId: trackingProps?.collectionId,
    pageNumber: trackingProps?.pageNumber,
    queryType: trackingProps?.queryType,
    resultCount: trackingProps?.resultCount ?? -1,
    resultIndex: trackingProps?.resultIndex ?? -1,
    search: trackingProps?.search,
    section: trackingProps?.section,
    value: trackingProps?.value,

    // other
    componentType,
    hostApp: trackingProps?.hostApp ?? getHostAppName(),
    resultType: 'LISTING',
  };
}
